import styled, { css } from 'styled-components';


export const InfoContainer = styled.div`
  width: 500px;
  position: relative;
  left: -250px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
  background: white;

  &:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #fff;
    border-width: 16px;
    margin-left: -16px;
  }
`;

export const ContainerHeader = styled.div`
  background: #263465;
  padding: 16px;
  color: white;
  display: flex;
  align-items: center;

  h2 {
    flex: 1;
    font-size: 18px;
    line-height: 23px;
    margin: 0;
  }

  p {
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    margin: 0;
  }
`;

export const ContentContainer = styled.div`
  padding: 16px;
  overflow: auto;
  height: 300px;
`;

export const ItemName = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  margin: 0;
  color: var(--luft-primary);
`;

export const ItemValue = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin: 0;
  color: ${({ statusColor }) => statusColor || '#292F36'};
`;

export const InfoWrapper = styled.div`
  margin-bottom: ${({ lastItem }) => (lastItem ? '0px' : '24px')};
  ${({ divider }) =>
    divider &&
    css`
      border-top: 1px solid #cccccc;
      padding-top: 24px;
      margin-right: -16px;
      margin-left: -16px;
      padding-right: 16px;
      padding-left: 16px;
    `}
`;

// export const BorderContainer = styled(Container)`
export const BorderContainer = styled.div`
  border: ${({ borderless }) => (borderless ? '' : '1px solid #CCCCCC')};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;
  margin-right: -16px;
  margin-left: -16px;
  padding-right: 16px;
  padding-left: 16px;
`;

export const CteTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const CteQuantity = styled.div`
  margin-bottom: 16px;

  span {
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    color: #263465;
  }
`;

export const CteNumber = styled.div`
  color: #1077b9;
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;

  span {
    font-size: 14px;
    line-height: 16px;
  }

  i {
    font-size: 18px;
    margin-left: 10px;
  }
`;

export const NfStatusContainer = styled.div`
  padding: 9px;
  border-bottom: ${({ lastItem }) => (lastItem ? '' : '1px solid #CCCCCC')};
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
    line-height: 14px;
    color: #292f36;
    flex: 1;
  }
`;

export const StatusContainer = styled.div`
  background-color: ${({ nfStatus, partial }) =>
    nfStatus && nfStatus ? '#4CAF50' : partial ? '#FF9800' : '#F44336'};
  min-width: 73px;
  max-width: 100px;
  padding: 3px 6px;
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
`;

export const DeliveryStatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StatusLight = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
  background: ${({ statusColor }) => statusColor && statusColor};
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ md6 }) =>
    md6 &&
    css`
      @media (min-width: 768px) {
        flex: 0 0 auto;
        width: 50%;
      }
    `}
`;
